import style from "./ExploreBlock.module.scss";
import dynamic from "next/dynamic";

const DynamicExploreIcon = dynamic(() => import("./ExploreIcon"), { ssr: false });

function ExploreBlock({ dictionary }) {
	let title = dictionary["Explore a new level of creativity"];
	let description = dictionary["Our advanced text-to-image AI generator"];

	return (
		<section className={style.block}>
			<div className={style.content}>
				<div className={style.text}>
					<h2 className={style.title}>{title}</h2>
					<p className={style.description}>{description}</p>
				</div>
				<DynamicExploreIcon />
			</div>
		</section>
	);
}

export default ExploreBlock;
